import { requireEnv } from './require-env';

type RequestConfig = {
  baseUrl: string;
  aiBotBaseUrl: string;
  crmBaseUrl: string;
  crmBaseUrlWL: string;
};

const requestConfig: RequestConfig = {
  baseUrl: requireEnv('REACT_APP_API_BASE_URL'),
  aiBotBaseUrl: requireEnv('REACT_APP_AI_API_BASE_URL'),
  crmBaseUrl: requireEnv('REACT_APP_CRM_API_BASE_URL'),
  crmBaseUrlWL: requireEnv('REACT_APP_CRM_API_BASE_URL_WL'),
};

export default requestConfig;
